import api from "plus/api";

/**
 * 账号开通（ACCOUNT_CREATION）工单：状态、校验与载荷构建
 * 合并到入口页 write.vue，由 FormAccount 仅负责模板展示
 */
export default {
  data() {
    return {
      acctEmployeeUsers: [],
      acctEmployeePosition: "",
      acctEmployeePhone: "",
      acctApplyDateYmd: "",
      acctSelectedSoftwareIds: [],
      acctSystemPermissions: {},
      acctSoftwareOptions: [],
      acctEmployeeArchiveLoading: false,
    };
  },
  computed: {
    acctApplyDeptName() {
      const u = this.$store.state.userInfo || {};
      return u.deptName || "";
    },
    acctSoftwareAcceptorsLine() {
      const names = [];
      const seen = new Set();
      for (const sid of this.acctSelectedSoftwareIds) {
        const row = this.findAcctSoftwareRow(sid);
        const h = row && (row.handlerName || row.handler);
        if (h && String(h).trim()) {
          const t = String(h).trim();
          const key =
            row.handlerUserId != null ? String(row.handlerUserId) : t;
          if (!seen.has(key)) {
            seen.add(key);
            names.push(t);
          }
        }
      }
      return names.join("、");
    },
    acctApprovalPreviewNodes() {
      return [
        { title: "直属上级审批", sub: "提交人直接上级" },
        { title: "风控审批", sub: "风控" },
      ];
    },
  },
  methods: {
    resetAccountCreationState() {
      this.acctEmployeeUsers = [];
      this.acctEmployeePosition = "";
      this.acctEmployeePhone = "";
      this.acctApplyDateYmd = "";
      this.acctSelectedSoftwareIds = [];
      this.acctSystemPermissions = {};
      this.acctSoftwareOptions = [];
      this.acctEmployeeArchiveLoading = false;
    },
    async bootstrapAccountCreationForm() {
      this.resetAccountCreationState();
      await this.loadAcctSoftwareOptions();
      this.acctApplyDateYmd = this.formatDateYmd(new Date());
      this.$nextTick(() => {
        this.prefillAcctEmployeeWithCurrentUser();
      });
    },
    async loadAcctSoftwareOptions() {
      try {
        const res = await api.work.getSoftwareDropdown();
        const list = (res.data && res.data.data) || [];
        this.acctSoftwareOptions = Array.isArray(list) ? list : [];
        this.pruneAcctSoftwareSelectionWithoutHandler();
      } catch (e) {
        this.acctSoftwareOptions = [];
        this.$message.error("软件列表加载失败");
      }
    },
    acctSoftwareHasHandlerRow(sw) {
      if (!sw) {
        return false;
      }
      const uid = sw.handlerUserId;
      if (uid === null || uid === undefined) {
        return false;
      }
      if (typeof uid === "string" && uid.trim() === "") {
        return false;
      }
      return true;
    },
    acctSoftwareOptionLabel(sw) {
      const name = (sw && (sw.softwareName || sw.name)) || "系统";
      if (!this.acctSoftwareHasHandlerRow(sw)) {
        return `${name}（系统未配置处理人）`;
      }
      return name;
    },
    pruneAcctSoftwareSelectionWithoutHandler() {
      const raw = this.acctSelectedSoftwareIds || [];
      const next = raw.filter((id) => {
        const row = this.findAcctSoftwareRow(id);
        return row && this.acctSoftwareHasHandlerRow(row);
      });
      if (next.length !== raw.length) {
        this.acctSelectedSoftwareIds = next;
        this.syncAcctSystemPermissionKeys(next);
      }
    },
    softwareRowId(sw) {
      if (!sw) return undefined;
      if (sw.id != null && sw.id !== "") return sw.id;
      return sw.softwareId;
    },
    findAcctSoftwareRow(sid) {
      if (sid === undefined || sid === null || sid === "") {
        return null;
      }
      return this.acctSoftwareOptions.find(
        (x) => String(this.softwareRowId(x)) === String(sid),
      );
    },
    acctSoftwareNameById(sid) {
      const row = this.findAcctSoftwareRow(sid);
      return (row && (row.softwareName || row.name)) || "系统";
    },
    onAcctSoftwareSelectionChange(selectedIds) {
      const raw = selectedIds || [];
      const next = raw.filter((id) => {
        const row = this.findAcctSoftwareRow(id);
        return row && this.acctSoftwareHasHandlerRow(row);
      });
      if (next.length !== raw.length) {
        this.$nextTick(() => {
          this.acctSelectedSoftwareIds = next;
          this.syncAcctSystemPermissionKeys(next);
        });
        return;
      }
      this.syncAcctSystemPermissionKeys(next);
    },
    syncAcctSystemPermissionKeys(next) {
      const nextSet = new Set((next || []).map((x) => String(x)));
      Object.keys(this.acctSystemPermissions).forEach((k) => {
        if (!nextSet.has(String(k))) {
          this.$delete(this.acctSystemPermissions, k);
        }
      });
      (next || []).forEach((id) => {
        const key = String(id);
        if (!(key in this.acctSystemPermissions)) {
          this.$set(this.acctSystemPermissions, key, "");
        }
      });
    },
    prefillAcctEmployeeWithCurrentUser() {
      const uid =
        this.$store.state.userInfo && this.$store.state.userInfo.userId;
      if (!uid || !this.allUserOptions.length) {
        return;
      }
      const u = this.allUserOptions.find((x) => x.userId === uid);
      if (u) {
        this.acctEmployeeUsers = [u];
        this.onAcctEmployeeChange();
      }
    },
    async onAcctEmployeeChange() {
      this.acctEmployeePosition = "";
      this.acctEmployeePhone = "";
      if (!this.acctEmployeeUsers.length) {
        return;
      }
      const user = this.acctEmployeeUsers[0];
      const bid = user.beisenUserId;
      if (bid == null || bid === "") {
        this.$message.warning("该员工北森ID为空，无法拉取档案");
        return;
      }
      this.acctEmployeeArchiveLoading = true;
      try {
        const res = await api.work.getUserArchive({ beisenUserId: bid });
        if (!res.data.success || !res.data.data) {
          throw new Error(res.data.msg || "获取用户档案失败");
        }
        const arc = res.data.data;
        this.acctEmployeePosition = arc.userPost || "";
        this.acctEmployeePhone = (arc.mobilePhone || "").trim();
      } catch (e) {
        this.$message.error((e && e.message) || "获取员工档案失败");
      } finally {
        this.acctEmployeeArchiveLoading = false;
      }
    },
    // validateAcctPhoneField() {
    //   const p = (this.acctEmployeePhone || "").trim();
    //   if (!p) {
    //     return;
    //   }
    //   if (!/^1\d{10}$/.test(p)) {
    //     this.$message.error("手机号必须为11位数字且以1开头");
    //   }
    // },
    isAcctPhoneValid() {
      const p = (this.acctEmployeePhone || "").trim();
      return /^1\d{10}$/.test(p);
    },
    validateAccountCreationForm() {
      if (!this.acctEmployeeUsers.length) {
        return "请选择开通员工姓名";
      }
      if (!this.acctApplyDateYmd) {
        return "申请日期缺失";
      }
      if (!this.isAcctPhoneValid()) {
        return "开通员工手机号格式不正确，请输入11位数字手机号";
      }
      if (!this.acctSelectedSoftwareIds.length) {
        return "请至少选择一个申请系统";
      }
      for (const sid of this.acctSelectedSoftwareIds) {
        const row = this.findAcctSoftwareRow(sid);
        if (!row || !this.acctSoftwareHasHandlerRow(row)) {
          return `「${this.acctSoftwareNameById(
            sid,
          )}」未配置处理人，请取消选择或联系管理员`;
        }
        const key = String(sid);
        const detail = (this.acctSystemPermissions[key] || "").trim();
        if (!detail) {
          return `请填写「${this.acctSoftwareNameById(sid)}」需要的权限内容`;
        }
      }
      return "";
    },
    buildAccountCreationPayload() {
      const user = this.acctEmployeeUsers[0];
      const storeUser = this.$store.state.userInfo || {};
      const applySystems = this.acctSelectedSoftwareIds.map((sid) => {
        const row = this.findAcctSoftwareRow(sid);
        const key = String(sid);
        const rawId = row != null ? this.softwareRowId(row) : sid;
        const systemId = Number(rawId);
        return {
          systemId: Number.isFinite(systemId) ? systemId : 0,
          systemName: (row && (row.softwareName || row.name)) || "",
          permissionDetails: (this.acctSystemPermissions[key] || "").trim(),
        };
      });
      return {
        applyDeptId:
          storeUser.deptId != null && storeUser.deptId !== ""
            ? String(storeUser.deptId)
            : "",
        applyDeptName: this.acctApplyDeptName || "",
        applyDeptNamePath:
          storeUser.deptNamePath ||
          storeUser.deptPath ||
          storeUser.deptFullName ||
          "",
        applyDate: this.dayEndIsoFromYmd(this.acctApplyDateYmd),
        employeeId: user.userId != null ? String(user.userId) : "",
        employeeName: user.userName || "",
        employeePosition: this.acctEmployeePosition || "",
        employeePhone: (this.acctEmployeePhone || "").trim(),
        applySystems,
      };
    },
  },
};
